import React from 'react';
// import { Row, Col } from 'antd';
import ReportGrid from '../../../../components/ReportGrid'
import { returnDataArrayObject } from '../../../../utils/arrayHelper';
import NotFound from '../../../../components/NotFound';

/* Raw Data is a preview - it exists to show what the resource returns, not to browse it.
   A handful of rows answers that, and it keeps the sidebar panel short. */
const PREVIEW_ROW_COUNT = 5;

export default function ResourceRowData(props) {
    const reportDataArr = returnDataArrayObject(props.reportDataObject) ? returnDataArrayObject(props.reportDataObject) : [];
    const previewData = reportDataArr && Array.isArray(reportDataArr.data)
        ? { ...reportDataArr, data: reportDataArr.data.slice(0, PREVIEW_ROW_COUNT) }
        : reportDataArr;
    // const availableFields= Object.keys(reportDataArr.data[0]).map((x, i) => {
    //     return {
    //     title: x,
    //           dataIndex: x,
    //           key: `x_key${i}`,
    //     }
    // })
    // useEffect(() => {
    //     console.log("props.reportDataObject===>>", props.reportDataObject)
    // }, [props.reportDataObject])


    if(props.reportDataObject===undefined) {
        return (<div><NotFound /></div>)
    }

    /* Nothing to preview - the request failed (the editor stores [] for a 4xx/5xx)
       or the API answered with no rows. Say so rather than drawing an empty grid. */
    // null = no resource picked yet (or still loading), which keeps the NotFound below
    if (props.reportDataObject && (!previewData || !Array.isArray(previewData.data) || !previewData.data.length)) {
        return (
            <div className="raw-data-empty">
                This resource returned no data. Check that it works with Test API on the Resources page, including its
                body and authentication.
            </div>
        )
    }

        return (

            <div className="raw-data-grid">
                {returnDataArrayObject(props.reportDataObject) ?
                    // only a few rows, so there is nothing to page through
                    <ReportGrid reportData={previewData} hidePagination />
                    : <div><NotFound /></div>
                }
            </div>

        )

}
